__turbopack_context__.v({
  "className": "caveat_3b637443-module__xFtFLq__className",
});
